<template>
  <div>
    <h2 class="fs40 pb-20 pb-md-40">Investment info</h2>

    <TextBlock class="details mt-0 mb-20 mb-lg-30">
      <b-row class="pb-16">
        <b-col md="3">
          Invests in
        </b-col>
        <b-col>
          <div class="stages">
            <div
              v-for="(stage, i) in stages"
              :key="i"
              class="stage"
              :class="{
                'is-active': (investor.stages || []).indexOf(stage.value) > -1
              }"
            >
              <div class="icon">
                <img
                  :src="
                    require('~/assets/img/icons/stages/' + stage.value + '.svg')
                  "
                  alt=""
                />
              </div>
              <div class="label">{{ stage.label }}</div>
            </div>
          </div>
        </b-col>
      </b-row>

      <b-row v-if="ranges.length" class="pb-16" align-v="center">
        <b-col md="3">
          Investment range
        </b-col>
        <b-col>
          <div class="ranges">
            <div v-for="(range, i) in ranges" :key="i" class="range">
              {{ range }}
            </div>
          </div>
        </b-col>
      </b-row>

      <b-row v-if="marketsFormatted" class="pb-16">
        <b-col md="3">
          Primary markets
        </b-col>
        <b-col>
          <strong class="text-gray-900">{{ marketsFormatted }}</strong>
        </b-col>
      </b-row>

      <b-row v-if="countriesFormatted" class="pb-16">
        <b-col md="3">
          Investing in countries
        </b-col>
        <b-col>
          <strong class="text-gray-900">{{ countriesFormatted }}</strong>
        </b-col>
      </b-row>

      <b-row v-if="investor.regions" class="pb-16">
        <b-col md="3">
          Regional investments
        </b-col>
        <b-col>
          <span class="text-gray-900">{{ investor.regions }}</span>
        </b-col>
      </b-row>
    </TextBlock>
  </div>
</template>

<script>
import url from 'url'
import TextBlock from '@/components/TextBlock'

export default {
  name: 'InvestorsInfo',
  components: {
    TextBlock
  },
  props: {
    investor: {
      type: Object,
      required: true
    }
  },
  computed: {
    stages() {
      return this.$store.getters['meta/companyStages'].filter((stage) => {
        return (this.investor.stages || []).indexOf(stage.value) > -1
      })
    },
    ranges() {
      const ranges = this.$store.getters['meta/investorInvestmentRanges']

      return ranges
        .filter((item) => {
          return (this.investor.investmentRanges || []).indexOf(item.value) > -1
        })
        .map((item) => item.label)
    },
    marketsFormatted() {
      const markets = this.$store.getters['meta/investorMarkets']

      return markets
        .filter((item) => {
          return (this.investor.markets || []).indexOf(item.value) > -1
        })
        .map((item) => item.label)
        .join(', ')
    },
    countriesFormatted() {
      const countries = this.$store.getters['meta/siteCountries']

      return countries
        .filter((item) => {
          return (
            (this.investor.countryCodes || []).findIndex((country) => {
              return item.value === country
            }) > -1
          )
        })
        .map((item) => item.text)
        .join(', ')
    },
    formattedWebsite() {
      if (!this.investor.website) {
        return null
      }

      const parts = url.parse(this.investor.websiteUrl)
      return parts.hostname && parts.hostname.replace(/^www\./, '')
    }
  }
}
</script>

<style lang="scss" scoped>
.ranges {
  display: flex;
  flex-wrap: wrap;
}

.range {
  border: 1px solid $border-color;
  padding: rem(5px) rem(12px);
  margin: 0 rem(5px) rem(5px) 0;
}

.stages {
  display: flex;
  flex-wrap: wrap;
  margin: -4px;
}

.stage {
  width: rem(100px);
  height: rem(100px);
  border: 1px solid #c4c4c4;
  margin: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  &:not(.is-active) {
    opacity: 0.3;
  }

  .icon {
    padding-bottom: rem(8px);

    img {
      height: 32px;
    }
  }

  .label {
    font-size: rem(12px);
    line-height: rem(12px);
    height: 26px;
    text-align: center;
    display: flex;
    align-items: center;
  }
}
</style>
